(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["planner-quiz-launcher"] && !Shopify.designMode) return;
  try {
    (function () {
    function initPlannerQuizLauncher() {
      var root = document.getElementById('ld-quiz-launcher');
      if (!root || root.getAttribute('data-ld-quiz-bound') === '1') return;
      root.setAttribute('data-ld-quiz-bound', '1');

      document.documentElement.classList.add('ld-quiz-launcher-on');

      var tab = document.getElementById('ld-quiz-launcher-tab');
      var dialog = document.getElementById('ld-quiz-launcher-dialog');
      var closeBtn = document.getElementById('ld-quiz-launcher-dialog-close');
      var iframe = document.getElementById('ld-quiz-launcher-iframe');
      if (!tab || !dialog || !closeBtn || !iframe) return;

      var delay = parseInt(root.getAttribute('data-delay-ms') || '5000', 10);
      if (window.Shopify && Shopify.designMode) delay = 0;

      var shown = false;
      var posRaf = 0;
      var posTrailing = 0;
      var lastPosAt = 0;
      var POS_THROTTLE_MS = 100;
      var cache = { at: 0, ttl: 0 };
      var CACHE_TTL_MS = 2000;
      var CACHE_TTL_RESIZE_MS = 0;

      function isOurs(el) {
        return !el || el === root || root.contains(el) || (dialog && dialog.contains(el));
      }

      function isSkippedRoot(el) {
        return !el || el === document.body || el === document.documentElement;
      }

      function styleOf(el) {
        try {
          return window.getComputedStyle(el);
        } catch (err) {
          return null;
        }
      }

      function isPainted(el, st) {
        st = st || styleOf(el);
        if (!st) return false;
        if (st.display === 'none' || st.visibility === 'hidden' || Number(st.opacity) === 0) return false;
        return true;
      }

      function hint(el) {
        var id = el.id || '';
        var cls = '';
        try {
          cls = (el.className && el.className.baseVal) || el.className || '';
        } catch (err) {
          cls = '';
        }
        return (id + ' ' + cls).toLowerCase();
      }

      function rectsOverlap(a, b) {
        return !(a.right < b.left || a.left > b.right || a.bottom < b.top || a.top > b.bottom);
      }

      var lastTeaserSweepAt = 0;

      function hideTeaserVisually(el) {
        if (!el) return;
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      }

      function hideOverwhelmWidgets() {
        document.querySelectorAll('[data-testid="animated-teaser"]').forEach(hideTeaserVisually);
        var now = Date.now();
        if (now - lastTeaserSweepAt < 1000) return;
        lastTeaserSweepAt = now;
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        document.querySelectorAll('.needsclick').forEach(function (el) {
          if (isOurs(el) || isSkippedRoot(el)) return;
          if ((el.getAttribute('role') || '') === 'dialog') return;
          if (el.getAttribute('data-testid') === 'POPUP') return;
          if (el.closest && el.closest('[role="dialog"], [data-testid="POPUP"]')) return;
          if (el.querySelector && el.querySelector('[data-testid="POPUP"], [role="dialog"]')) return;
          var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (!t || t.length > 120) return;
          if (t.indexOf('overwhelm') === -1 && t.indexOf('take the quiz') === -1) return;
          var r = el.getBoundingClientRect();
          if (r.width > 360 || r.height > 140) return;
          if (r.width > vw * 0.55 || r.height > vh * 0.28) return;
          hideTeaserVisually(el);
        });
      }

      function invalidateCache() {
        cache.at = 0;
        cache.ttl = CACHE_TTL_RESIZE_MS;
      }

      function queryCache(force) {
        var now = Date.now();
        var ttl = cache.ttl || CACHE_TTL_MS;
        if (!force && cache.at && now - cache.at < ttl && cache.atc) return cache;
        cache.atc = document.querySelectorAll(
          '.cro-sticky-bar, .cro-sticky-bar--bottom, #corner-sticky-atc-outer-container, #corner-sticky-atc-container, .sticky-atc-bar-wrapper, [class*="sticky-atc"], [id*="sticky-atc"]'
        );
        cache.left = document.querySelectorAll(
          '#acsb-trigger, button[part="acsb-trigger"], .acsb-trigger, .acsb-widget, [class*="acsb-trigger"], access-widget-ui'
        );
        cache.footerLegal = document.querySelector(
          '.footer-desktop .frame-23, #shopify-section-theme-footer .frame-23'
        );
        cache.footerDock = document.querySelector(
          '.footer-desktop .frame-22, #shopify-section-theme-footer .frame-22'
        );
        cache.story = document.querySelector('#hp-story-section, .hp-story');
        cache.mainAtc = document.querySelector(
          '#action-container button[type="submit"], #action-container .button button.active'
        );
        cache.zendesk = document.querySelector('iframe#launcher');
        cache.popups = document.querySelectorAll(
          '.needsclick, [role="dialog"], [class*="klaviyo-form"], [class*="Klaviyo"], [data-testid="POPUP"], [data-testid="form"]'
        );
        cache.shadowHosts = document.querySelectorAll(
          'access-widget-ui, acsb-trigger, [id*="acsb"], [class*="acsb"], [id*="corner-sticky"], [class*="cro-sticky"], [class*="sticky-atc"]'
        );
        cache.at = now;
        cache.ttl = CACHE_TTL_MS;
        return cache;
      }

      function dockClearance() {
        var vh = window.innerHeight;
        var vw = window.innerWidth;
        var mobile = vw < 768;
        var gap = 10;
        var bottom = 12 + (window.visualViewport ? Math.max(0, vh - window.visualViewport.height) : 0);
        var left = mobile ? 48 : 72;
        var rightReserve = 88;
        var hideForStory = false;
        var foundAtc = false;
        var nodes = queryCache(false);

        function considerAtc(el) {
          if (isOurs(el) || isSkippedRoot(el)) return;
          var r = el.getBoundingClientRect();
          if (r.width < vw * 0.55 || r.height < 28 || r.height > 220) return;
          if (r.top > vh || r.bottom < vh - 32) return;
          var st = styleOf(el);
          if (!isPainted(el, st)) return;
          var isFixed = st.position === 'fixed' || st.position === 'sticky';
          var looksAtc = /sticky|atc|cro-/.test(hint(el));
          if (!isFixed && !looksAtc) return;
          foundAtc = true;
          bottom = Math.max(bottom, vh - r.top + gap);
        }

        function isTableLike(el) {
          if (!el) return false;
          var tag = (el.tagName || '').toLowerCase();
          if (
            tag === 'td' ||
            tag === 'th' ||
            tag === 'tr' ||
            tag === 'table' ||
            tag === 'tbody' ||
            tag === 'thead' ||
            tag === 'tfoot' ||
            tag === 'col' ||
            tag === 'colgroup' ||
            tag === 'caption'
          ) {
            return true;
          }
          try {
            if (el.closest && el.closest('table, .comparison-table-wrapper, [class*="comparison-table"]')) {
              return true;
            }
          } catch (err) {}
          return false;
        }

        function isKnownSideWidget(el) {
          var tag = (el.tagName || '').toLowerCase();
          if (tag === 'access-widget-ui' || tag === 'acsb-trigger') return true;
          return /acsb|access-widget|zendesk/.test(hint(el));
        }

        function considerLeftWidget(el) {
          if (isOurs(el) || isSkippedRoot(el)) return;
          if (isTableLike(el)) return;
          var r = el.getBoundingClientRect();
          if ((r.width < 16 || r.height < 16) && el.shadowRoot) {
            var trigger = el.shadowRoot.querySelector('button[part="acsb-trigger"], [part="acsb-trigger"]');
            if (trigger) {
              considerLeftWidget(trigger);
              r = trigger.getBoundingClientRect();
            }
          }
          if (r.width < 16 || r.height < 16 || r.width > 140 || r.height > 140) return;
          if (r.top > vh || r.bottom < vh * 0.7) return;
          var st = styleOf(el);
          if (!isPainted(el, st) && !(el.shadowRoot && r.width >= 16)) return;
          var pos = st && st.position;
          var known = isKnownSideWidget(el);
          if (pos !== 'fixed' && !(known && (pos === 'sticky' || pos === 'absolute'))) return;
          if (r.left < 110 && r.right > 4) {
            left = Math.max(left, Math.round(r.right + gap));
          }
        }

        function considerRightWidget(el) {
          if (!el || isOurs(el) || isSkippedRoot(el)) return;
          var r = el.getBoundingClientRect();
          if (r.width < 16 || r.height < 16) return;
          if (r.top > vh || r.bottom < vh * 0.55) return;
          if (r.left < vw * 0.55) return;
          var st = styleOf(el);
          if (!isPainted(el, st)) return;
          rightReserve = Math.max(rightReserve, Math.round(vw - r.left + 12));
        }

        for (var n = 0; n < nodes.atc.length; n++) considerAtc(nodes.atc[n]);
        for (var a = 0; a < nodes.left.length; a++) considerLeftWidget(nodes.left[a]);
        considerRightWidget(nodes.zendesk);

        for (var h = 0; h < nodes.shadowHosts.length; h++) {
          var host = nodes.shadowHosts[h];
          var sr = host.shadowRoot;
          considerAtc(host);
          considerLeftWidget(host);
          if (!sr) continue;
          var kids = sr.querySelectorAll('*');
          var kidLimit = Math.min(kids.length, 80);
          for (var k = 0; k < kidLimit; k++) {
            considerAtc(kids[k]);
            considerLeftWidget(kids[k]);
          }
        }

        var footerEl = foundAtc
          ? nodes.footerLegal || nodes.footerDock
          : nodes.footerDock || nodes.footerLegal;
        if (footerEl) {
          var cr = footerEl.getBoundingClientRect();
          if (cr.height > 4 && cr.top < vh && cr.bottom > 0) {
            var tabH = 36;
            try {
              var measuredTabH = tab.getBoundingClientRect().height;
              if (measuredTabH >= 20 && measuredTabH <= 80) tabH = measuredTabH;
            } catch (err) {}
            var tabBox = {
              left: left,
              right: Math.min(vw - rightReserve, left + 360),
              top: vh - tabH - bottom,
              bottom: vh - bottom
            };
            var footerBox = {
              left: cr.left,
              right: cr.right,
              top: cr.top - gap,
              bottom: cr.bottom + gap
            };
            if (rectsOverlap(tabBox, footerBox)) {
              bottom = Math.max(bottom, Math.round(vh - cr.top + gap));
            }
          }
        }

        if (nodes.popups && nodes.popups.length) {
          for (var p = 0; p < nodes.popups.length; p++) {
            var popup = nodes.popups[p];
            if (isOurs(popup) || isSkippedRoot(popup)) continue;
            var pst = styleOf(popup);
            if (!pst || pst.display === 'none') continue;
            var isDialog = (popup.getAttribute('role') || '') === 'dialog';
            var testid = popup.getAttribute('data-testid') || '';
            if (!isDialog && testid !== 'POPUP' && pst.position !== 'fixed' && pst.position !== 'sticky') continue;
            var pr = popup.getBoundingClientRect();
            if (pr.width < 160 || pr.height < 160) continue;
            if (pr.bottom < 0 || pr.top > vh || pr.right < 0 || pr.left > vw) continue;
            var zIndex = parseInt(pst.zIndex, 10);
            var coversViewport = pr.width >= vw * 0.4 && pr.height >= vh * 0.3;
            if (coversViewport && (isDialog || testid === 'POPUP' || (!isNaN(zIndex) && zIndex >= 1000))) {
              hideForStory = true;
              break;
            }
            if (!isPainted(popup, pst)) continue;
            if (isDialog && coversViewport) {
              hideForStory = true;
              break;
            }
            var probePopup = { left: left, right: left + 240, top: vh - 44 - bottom, bottom: vh - bottom };
            if (rectsOverlap(probePopup, pr)) {
              hideForStory = true;
              break;
            }
          }
        }

        if (nodes.story && shown) {
          var srStory = nodes.story.getBoundingClientRect();
          var probe = {
            left: left,
            right: left + 240,
            top: vh - 44 - bottom,
            bottom: vh - bottom
          };
          if (rectsOverlap(probe, srStory)) hideForStory = true;
        }

        try {
          var hitX = Math.min(Math.max(left + 24, 12), vw - 12);
          var hitY = Math.max(4, vh - Math.min(bottom, 16) - 4);
          var stack = document.elementsFromPoint(hitX, hitY) || [];
          var stackLimit = Math.min(stack.length, 12);
          for (var s = 0; s < stackLimit; s++) {
            var node = stack[s];
            for (var depth = 0; depth < 10 && node && node !== document.documentElement; depth++) {
              considerAtc(node);
              considerLeftWidget(node);
              var hr = node.getBoundingClientRect();
              var hs = styleOf(node);
              if (
                hs &&
                isPainted(node, hs) &&
                hr.width >= vw * 0.55 &&
                hr.height >= 28 &&
                hr.height <= 160 &&
                hr.bottom >= vh - 12 &&
                hr.top < vh &&
                (hs.position === 'fixed' || hs.position === 'sticky' || /sticky|atc|cro-/.test(hint(node)))
              ) {
                foundAtc = true;
                bottom = Math.max(bottom, vh - hr.top + gap);
              }
              node = node.parentElement || (node.getRootNode && node.getRootNode().host) || null;
            }
          }
        } catch (err) {}

        if (nodes.mainAtc && isPainted(nodes.mainAtc)) {
          var ar = nodes.mainAtc.getBoundingClientRect();
          if (ar.width >= 80 && ar.height >= 28 && ar.top < vh && ar.bottom > 0) {
            var tabBox = {
              left: left,
              right: Math.min(vw - rightReserve, left + 240),
              top: vh - 36 - bottom,
              bottom: vh - bottom
            };
            if (rectsOverlap(tabBox, ar)) {
              var liftForMain = Math.round(vh - ar.top + gap);
              if (liftForMain <= Math.round(vh * 0.35)) {
                bottom = Math.max(bottom, liftForMain);
              } else {
                hideForStory = true;
              }
            }
          }
        }

        if (bottom > vh * 0.35) bottom = Math.round(vh * 0.35);
        if (left > vw * 0.42) left = Math.round(vw * 0.42);
        if (rightReserve > vw * 0.45) rightReserve = Math.round(vw * 0.45);
        if (!foundAtc && bottom < 12) bottom = 12;

        return {
          bottom: Math.round(bottom),
          left: Math.round(left),
          right: Math.round(rightReserve),
          hideForStory: hideForStory
        };
      }

      function position() {
        if (!shown) return;
        hideOverwhelmWidgets();
        var pos = dockClearance();
        root.style.setProperty('--ld-quiz-bottom', pos.bottom + 'px');
        root.style.setProperty('--ld-quiz-left', pos.left + 'px');
        root.style.setProperty('--ld-quiz-right', pos.right + 'px');
        if (pos.hideForStory) root.classList.add('is-parked');
        else root.classList.remove('is-parked');
        lastPosAt = Date.now();
      }

      function runPositionSoon() {
        posRaf = 0;
        position();
      }

      function schedulePosition() {
        var now = Date.now();
        var elapsed = now - lastPosAt;
        if (posRaf) return;
        if (!lastPosAt || elapsed >= POS_THROTTLE_MS) {
          posRaf = window.requestAnimationFrame(runPositionSoon);
          return;
        }
        if (!posTrailing) {
          posTrailing = window.setTimeout(function () {
            posTrailing = 0;
            if (posRaf) return;
            posRaf = window.requestAnimationFrame(runPositionSoon);
          }, POS_THROTTLE_MS - elapsed);
        }
      }

      function schedulePositionFresh() {
        invalidateCache();
        lastPosAt = 0;
        if (posTrailing) {
          window.clearTimeout(posTrailing);
          posTrailing = 0;
        }
        schedulePosition();
      }

      function reveal() {
        if (shown) return;
        shown = true;
        root.hidden = false;
        root.classList.add('is-ready');
        tab.removeAttribute('tabindex');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            root.classList.add('is-visible');
            invalidateCache();
            position();
            [200, 600, 1200, 2500, 4500, 7000].forEach(function (ms) {
              window.setTimeout(function () {
                invalidateCache();
                position();
              }, ms);
            });
          });
        });
      }

      function openQuiz() {
        if (!iframe.getAttribute('src')) {
          iframe.src = iframe.getAttribute('data-src') || 'https://ldplanner.electricenjin.com';
        }
        try {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          tab.setAttribute('aria-expanded', 'true');
          document.body.classList.add('no-scroll');
          closeBtn.focus();
          return;
        } catch (err) {}
        var fallback = root.getAttribute('data-quiz-url');
        if (fallback) window.location.href = fallback;
      }

      function returnFocusToLauncher() {
        tab.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('no-scroll');
        root.classList.add('is-returning-focus');
        function focusTab() {
          if (dialog.open) return;
          try {
            tab.focus({ preventScroll: true });
          } catch (err) {
            tab.focus();
          }
        }
        focusTab();
        window.requestAnimationFrame(function () {
          focusTab();
          window.setTimeout(function () {
            focusTab();
            root.classList.remove('is-returning-focus');
          }, 40);
        });
      }

      function closeQuiz() {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        returnFocusToLauncher();
      }

      tab.addEventListener('click', openQuiz);
      closeBtn.addEventListener('click', closeQuiz);
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeQuiz();
      });
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeQuiz();
      });
      dialog.addEventListener('close', function () {
        returnFocusToLauncher();
      });

      window.addEventListener('message', function (event) {
        if (event.origin !== 'https://ldplanner.electricenjin.com') return;
        if (event.data && event.data.height && iframe) {
          iframe.style.maxHeight = event.data.height + 'px';
        }
      });

      window.addEventListener('resize', schedulePositionFresh);
      window.addEventListener('orientationchange', function () {
        schedulePositionFresh();
        window.setTimeout(schedulePositionFresh, 120);
        window.setTimeout(schedulePositionFresh, 400);
      });
      window.addEventListener('scroll', schedulePosition, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', schedulePositionFresh);
        window.visualViewport.addEventListener('scroll', schedulePosition, { passive: true });
      }

      hideOverwhelmWidgets();
      if (window.MutationObserver) {
        var obs = new MutationObserver(function () {
          schedulePosition();
        });
        obs.observe(document.body, { childList: true, subtree: true });
        var bodyClassObs = new MutationObserver(function () {
          schedulePositionFresh();
        });
        bodyClassObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }

      tab.setAttribute('tabindex', '-1');
      window.setTimeout(reveal, delay);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPlannerQuizLauncher);
    } else {
      initPlannerQuizLauncher();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
